/* ----- Widget Registry ----- */
import { BaseWidget } from './BaseWidget'; // Import type only
import { Container } from './Container';
import { HeadingWidget } from './HeadingWidget';
import { NumberWidget } from './NumberWidget';
import { OutputWidget } from './OutputWidget';
import { ParagraphWidget } from './ParagraphWidget';
import { ResearchWidget } from './ResearchWidget';
import { QuestionWidget } from './QuestionWidget';
import { EffectWidget } from './EffectWidget';
import { ImageWidget } from './ImageWidget';
import { IconWidget } from './IconWidget';
import { LogoWidget } from './LogoWidget';
import { CompanyNameWidget } from './CompanyNameWidget';
import { QuoteWidget } from './QuoteWidget';
import { ActivityWidget } from './ActivityWidget';
import { StakeholderWidget } from './StakeholderWidget';
import { AnecdoteWidget } from './AnecdoteWidget';
import { HouseVisitsTotalWidget } from './HouseVisitsTotalWidget';
import { HouseVisitsStatusWidget } from './HouseVisitsStatusWidget';
import { HouseVisitsMeasuresWidget } from './HouseVisitsMeasuresWidget';
import { HouseVisitsAreaWidget } from './HouseVisitsAreaWidget';
import { PersonasTotalWidget } from './PersonasTotalWidget';
import { PersonasStatusWidget } from './PersonasStatusWidget';
import { PersonasRoutesWidget } from './PersonasRoutesWidget';
import { HouseVisitsHoursWidget } from './HouseVisitsHoursWidget';
import { HouseVisitsSisaWidget } from './HouseVisitsSisaWidget';
import { PersonasPresenceWidget } from './PersonasPresenceWidget';
import { PersonaPresenceWidget } from './PersonaPresenceWidget';
import { PersonaGoalsWidget } from './PersonaGoalsWidget';
import { PersonaGrowthWidget } from './PersonaGrowthWidget';
import { PersonaProfileWidget } from './PersonaProfileWidget';
import { PersonaLadderWidget } from './PersonaLadderWidget';
import { PersonaWorkSkillsWidget } from './PersonaWorkSkillsWidget';
import { PERSONA_WIDGET_TYPES } from '../../../../helpers/liveReportHelpers/personaWidgetTypes';

/**
 * Widget Registry mapping widget types to their classes
 * @type {Object.<string, typeof BaseWidget>}
 */
export const WIDGET_REGISTRY = {
    CONTAINER: Container,
    HEADING: HeadingWidget,
    PARAGRAPH: ParagraphWidget,
    NUMBER: NumberWidget,
    IMAGE: ImageWidget,
    ICON: IconWidget,
    LOGO: LogoWidget,
    COMPANY_NAME: CompanyNameWidget,
    QUOTE: QuoteWidget,
    OUTPUT: OutputWidget,
    RESEARCH: ResearchWidget,
    QUESTION: QuestionWidget,
    EFFECT: EffectWidget,
    ACTIVITY: ActivityWidget,
    STAKEHOLDER: StakeholderWidget,
    ANECDOTE: AnecdoteWidget,
    HOUSE_VISITS_TOTAL: HouseVisitsTotalWidget,
    HOUSE_VISITS_STATUS: HouseVisitsStatusWidget,
    HOUSE_VISITS_MEASURES: HouseVisitsMeasuresWidget,
    HOUSE_VISITS_AREA: HouseVisitsAreaWidget,
    PERSONAS_TOTAL: PersonasTotalWidget,
    PERSONAS_STATUS: PersonasStatusWidget,
    PERSONAS_ROUTES: PersonasRoutesWidget,
    HOUSE_VISITS_HOURS: HouseVisitsHoursWidget,
    HOUSE_VISITS_SISA: HouseVisitsSisaWidget,
    PERSONAS_PRESENCE: PersonasPresenceWidget,
    // Rapportage per deelnemer: de sleutel is het `Type` dat de openbare link
    // leest, dus uit de gedeelde constante (docs/features/livereport-per-deelnemer.md).
    [PERSONA_WIDGET_TYPES.PRESENCE]: PersonaPresenceWidget,
    [PERSONA_WIDGET_TYPES.GOALS]: PersonaGoalsWidget,
    [PERSONA_WIDGET_TYPES.GROWTH]: PersonaGrowthWidget,
    [PERSONA_WIDGET_TYPES.PROFILE]: PersonaProfileWidget,
    [PERSONA_WIDGET_TYPES.LADDER]: PersonaLadderWidget,
    [PERSONA_WIDGET_TYPES.WORK_SKILLS]: PersonaWorkSkillsWidget,
    // RESEARCH_CONTEXT: ResearchContextWidget,
}

export const WIDGET_REGISTRY_TO_KEY = new Map(
    Object.entries(WIDGET_REGISTRY).map(([key, value]) => [value, key])
);

/* Aliases */
export * from './BaseWidget';
export * from './HeadingWidget';
export * from './ParagraphWidget';
export * from './Container';
